import React, { Component } from 'react';
import './custom.css';

class MenuTree extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: false,
    };
  }

  renderOptions() {}

  render() {
    return (
      <li className="treeview">
        <a className="menu_item" href="#">
          <i className={`fa fa-${this.props.icon}`} /> <span>{this.props.label}</span>
          <span className="pull-right-container">
            <i className="fa fa-angle-left pull-right" />
          </span>
        </a>
        <ul className="treeview-menu">{this.props.children}</ul>
      </li>
    );
  }
}

export default MenuTree;
